export default function useDateString(value: Date, showTime = false) {
  value = new Date(value);
  
  //@ts-ignore
  const diffTime = Math.abs(new Date() - new Date(value));
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  if (new Date().getDate() === new Date(value).getDate() && new Date().getMonth() === new Date(value).getMonth()) {
    return "Today" + (showTime ? ", " + value.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "");
  }
  else if (new Date(new Date().setDate(new Date().getDate() - 1)).getDate() === new Date(value).getDate() && new Date().getMonth() === new Date(value).getMonth()) {
    return "Yesterday" + (showTime ? ", " + value.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "");
  }
  if (!showTime) {
    return value.toLocaleString("en-GB", { year: 'numeric', month: 'short', day: 'numeric' });
  }
  return value.toLocaleDateString("en-GB", { year: 'numeric', month: 'short', day: 'numeric' }) + (showTime ? ", " + value.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "");
}
